import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Uploads a bulk onboarding Excel file.
 * POST api/BulkUpload/upload-bulk-onboarding (new endpoint)
 * multipart/form-data: file + createdBy
 *
 * The API always returns HTTP 200 with:
 *   { success: boolean, message: string, data: [{ vendorId, validationMessage, isValid }] }
 *
 * success: true  → import succeeded (data may still have rows)
 * success: false → validation errors in data[]
 */
export const uploadBulkOnboardingAction = async (file, onProgress) => {
  try {
    const loggedInUser = getUserData();
    const createdBy =
      loggedInUser?.email ||
      loggedInUser?.name ||
      loggedInUser?.username ||
      "Admin";

    const formData = new FormData();
    formData.append("file", file);
    formData.append("createdBy", createdBy);

    const response = await apiClient.post(
      ATP_API_URL.BULK_UPLOAD_ONBOARDING_EXCELSHETT_NEW,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        // Don't let axios throw on non-2xx so we can read the validation data
        validateStatus: () => true,
        onUploadProgress: (e) => {
          if (onProgress && e.total) {
            onProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      },
    );

    // Read body regardless of HTTP status code
    const body = response?.data;
    if (body) {
      const { success, message, data } = body;
      return {
        success: !!success,
        message:
          message || (success ? "Uploaded successfully" : "Validation failed"),
        data: Array.isArray(data) ? data : [],
      };
    }

    return {
      success: false,
      message: `Upload failed (HTTP ${response?.status})`,
      data: [],
    };
  } catch (error) {
    // Network-level error — try to extract data from error.response too
    const errBody = error?.response?.data;
    if (errBody && Array.isArray(errBody.data) && errBody.data.length > 0) {
      return {
        success: false,
        message: errBody.message || "Validation failed",
        data: errBody.data,
      };
    }
    console.error("[BulkUploadOnboarding] error:", error);
    return {
      success: false,
      message:
        error?.response?.data?.message || error.message || "Upload failed",
      data: [],
    };
  }
};
